
export default function IconChatInfo({ size = 20, ...rest }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={{ minWidth: size, ...rest.style }} width={size} height={size} viewBox="0 -960 960 960" fill="currentColor" {...rest}>
      <path d="M480-680q17 0 28.5-11.5T520-720q0-17-11.5-28.5T480-760q-17 0-28.5 11.5T440-720q0 17 11.5 28.5T480-680Zm-40 320h80v-240h-80v240ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Z"/>
    </svg>
  );
}
